import { ROLE_DISPLAY_NAMES } from "../enums/user.enum";
import { Artifact } from "./artifact.model";

export class AppCertWizard {
    agentResponsibilityText = ''; //use in frontend only

    setAgentResponsibilityText(artifacts:Artifact[]){
        const agentArtifact = artifacts.find(i=> i.role !== 'Applicant');
        this.agentResponsibilityText = agentArtifact
            ? (ROLE_DISPLAY_NAMES[agentArtifact.role] || 'School System Responsibility')
            : 'School System Responsibility';
    }
}
